import { render, staticRenderFns } from "./RequestWorkTypes.vue?vue&type=template&id=4cf5630f&scoped=true&"
import script from "./RequestWorkTypes.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypes.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkTypes.vue?vue&type=style&index=0&id=4cf5630f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5630f",
  null
  
)

export default component.exports
import {QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip}, component.options.components || {})
